<template>
  <div>
    <div class="masking-container">
      <div class="top">
        <HeadTitle></HeadTitle>
      </div>
      <div class="content">
        <!-- <div class="content-left">
          <LeftCharts></LeftCharts>
        </div> -->
        <div class="content-middle">
          <MiddleStatistics></MiddleStatistics>
        </div>
        <!-- <div class="content-right">
          <RightCharts></RightCharts>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import HeadTitle from './HeadTitle.vue';
import MiddleStatistics from './MiddleStatistics-Ex.vue';
// import LeftCharts from './LeftCharts.vue';
// import RightCharts from './RightCharts.vue';

export default {
  name: 'MaskingLayer-Ex',
  components: {
    HeadTitle,
    MiddleStatistics,
    // LeftCharts,
    // RightCharts
  }
}
</script>

<style scoped>
.masking-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding: 0 30px;
  box-sizing: border-box;
}

.top {
  width: 100%;
  height: 15%;
  /* background-color: aquamarine; */
}

.content {
  width: 100%;
  height: 85%;
  display: flex;
}

.content-left {
  width: 30%;
  height: 100%;
  /* background-color: darkgreen; */
}

.content-middle {
  width: 100%;
  height: 100%;
  /* background-color: cadetblue; */
}

.content-right {
  width: 30%;
  height: 100%;
  /* background-color: goldenrod; */
}
</style>
